import React from 'react'

export default function Footer() {
  return (
    <div
      data-testid="app-footer"
      className='fixed bottom-0 left-0 right-0 z-40 px-6 py-2 text-center border-t'
      style={{
        backgroundColor: '#FFFFFF',
        borderColor: '#E4E4E7',
        color: '#A1A1AA',
        fontFamily: "'IBM Plex Sans', sans-serif",
        fontSize: '0.72rem',
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.1em'
      }}
    >Sales and Operations System</div>
  )
}
